import { useContext, useEffect, useState } from "react";
import Modal from 'react-modal';
import { refeshPend } from "../../App";
import { getApi } from "../../components/Admin Master/Area Control/Zonemaster/ServicesApi";
import '../Dashboard/Mainstyle.css';
import './searchbar.css';

function Searchbar() {
    const { docket, setDocket,pin,setPin } = useContext(refeshPend);
    const [searchValue, setSearchValue] = useState('');
    const [pincodeData, setPincodeData] = useState([]);
    const [searchTrackingValue, setSearchTrackingValue] = useState('');
    const [trackingData, setTrackingData] = useState([]);
    const [currentStep, setCurrentStep] = useState(1);
    const [showImage, setShowImage] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalIsOpen1, setModalIsOpen1] = useState(false);
    const [error, setError] = useState('');

    const handleInputChange = (e) => {
        const inputValue = e.target.value.replace(/\D/g, '');
        const sanitizedValue = inputValue.slice(0, 6);
        setSearchValue(sanitizedValue);
        setError('');
        setPincodeData([]);
    };

    const fetchData = async (pin) => {
        if (pin.length !== 6) {
            alert('Please enter a 6-digit PIN code.');
            return;
        }

        try {
            const response = await getApi(`/Master/PincodeFinder?pincode=${pin}`);
            if (response.status === 1 && Array.isArray(response.data) && response.data.length > 0) {
                setModalIsOpen(true);
                setPincodeData(response.data);
                setError('');
            } else {
                setPincodeData([]);
                setError('Invalid data format received.');
            }
        }
        catch (error) {
            setError('Failed to fetch data. Please check your internet connection.');
            setPincodeData([]);
        }
    };

    useEffect(() => {
        if (docket) {
            fetchTrackingData(docket);
        }
    }, [docket])


    useEffect(() => {
        if (pin) {
            fetchData(pin);
        }
    }, [pin])

   

    const handleButtonClick = () => {
        setShowImage(!showImage);
    };

    const fetchTrackingData = async (docket) => {
        if (!docket) {
            alert('Please enter docket no.');
            return;
        }
        try {
            const res = await getApi(`/Master/getTrackingData?DocketNo=${docket}`);
            if (res.status === 1 && res.Data) {
                setModalIsOpen1(true);
                const updatedData = res.Data.map((item) => {
                    const imageId = item.DocketNo;
                    return {
                        ...item,
                        ImageLink: `https://jdcargo.co.in/PODImg/POD_Image/${imageId}.jpg`,
                    };
                });

                setTrackingData(updatedData);
                setError('');

                
            } else {
                setTrackingData([]);
                setError('Docket Not Found');
            }
        } catch (error) {
            console.error('Error:', error);
            setError(
                error.response?.data?.message || 'Failed to fetch data. Please check your internet connection or try again later.'
            );
        }
    };


    return (
       
            
            <div className="search-bar">

                 <Modal
                    overlayClassName="custom-overlay"
                    isOpen={modalIsOpen}
                    className="custom-modal"
                    contentLabel="Modal"
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '95%',
                            overflowY: 'auto',     // ✅ enable vertical scroll
                            overflowX: 'auto',   // optional (clean UI)
                            zIndex: "999999999",
                        },
                    }}
                >
                    <div className="custom-modal-content">
                        <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                            <header className="" style={{ width: "95%", textAlign: "center" }}>Pin Code Finder</header>
                            <button className="ok-btn " style={{ width: "60px", height: "100%", backgroundColor: "red" }}
                                onClick={() => 
                                {
                                    setModalIsOpen(false);
                                    setPin("");
                                }
                                }>
                                <i className="bi bi-x-lg"></i>
                            </button>
                        </div>


                        <div className='container2' style={{padding:"15px",paddingTop:"0px"}}>
                            <div className="table-container">
                                <table className=" table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col">Sr.No</th>
                                            <th scope="col">Pincode</th>
                                            <th scope="col">Area_Name</th>
                                            <th scope="col">Destination_Name</th>
                                            <th scope="col">State_Name</th>
                                            <th scope="col">Service</th>
                                            <th scope="col">Post/Oda</th>
                                            <th scope="col">Vendor_Name</th>
                                            <th scope="col">Zone_Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pincodeData.map((pincode, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{pincode.Pincode}</td>
                                                <td>{pincode.Area_Name}</td>
                                                <td>{pincode.City_Name}</td>
                                                <td>{pincode.State_Name}</td>
                                                <td>{pincode.Serviceable}</td>
                                                <td>{pincode.ODA_OPA}</td>
                                                <td>{pincode.Vendor_Name}</td>
                                                <td>{pincode.Zone_Name}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Modal >
                <Modal
                    overlayClassName="custom-overlay"
                    isOpen={modalIsOpen1}
                    className="custom-modal"
                    contentLabel="Modal"
                    style={{
                        content: {
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '95%',
                            overflowY: 'auto',     // ✅ enable vertical scroll
                            overflowX: 'auto',   // optional (clean UI)
                            zIndex: "999999999",
                        },
                    }}
                >
                    <div className="custom-modal-content">
                        <div className="header-tittle" style={{ display: "flex", flexDirection: "row" }}>
                            <header className="" style={{ width: "95%", textAlign: "center" }}>Tracking Details</header>
                            <button className="ok-btn " style={{ width: "60px", height: "100%", backgroundColor: "red" }}
                                onClick={() => {
                                    setModalIsOpen1(false);
                                    setDocket('');
                                }}>
                                <i className="bi bi-x-lg"></i>
                            </button>
                        </div>

                        <div className="container2" style={{ padding: "10px" }}>

                            {trackingData.length > 0 ? (
                                trackingData.map((record, index) => (

                                    <div className="tables-wrapper" key={index} style={{ width: "100%" }}>

                                        {/* Table 1 */}
                                        <div className="table-container3">
                                            <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                                                <tbody>
                                                    <tr><td className="w-60">DocketNo</td><td>{record.DocketNo}</td></tr>
                                                    <tr><td className="w-60">Book Date</td><td>{record.BookDate}</td></tr>
                                                    <tr><td className="w-60">Consignee</td><td>{record.Consignee_Name}</td></tr>
                                                    <tr><td className="w-60">Origin</td><td>{record.OriginCity}</td></tr>
                                                    <tr><td className="w-60">Destination</td><td>{record.DestinationCity}</td></tr>
                                                    <tr><td className="w-60">Forwarding No</td><td>{record.VendorAwbNo}</td></tr>
                                                    <tr><td className="w-60">Delivery Status</td><td>{record.Status}</td></tr>
                                                    <tr><td className="w-60">Delivery Date</td><td>{record.DelvDT}</td></tr>
                                                    <tr><td className="w-60">Qty</td><td>{record.Qty}</td></tr>
                                                    <tr><td className="w-60">RecvName</td><td>{record.RecvName}</td></tr>
                                                    <tr><td className="w-60">ReceivedMo</td><td>{record.ReceivedMo}</td></tr>
                                                    <tr><td className="w-60">EWaybill</td><td>{record.EWaybill}</td></tr>

                                                    <tr><td className="w-60">Invoice No</td><td>{record.InvoiceNo}</td></tr>
                                                    <tr><td className="w-60">Pod Img</td><td>{record.PodImg}</td></tr>

                                                </tbody>
                                            </table>
                                        </div>

                                        {/* Table 2 */}
                                        <div className="table-container2">
                                            <table className="table table-bordered table-sm" style={{ whiteSpace: "nowrap" }}>
                                                <thead className="background">
                                                    <tr>
                                                        <th>Date</th>
                                                        <th>Time</th>
                                                        <th>Location</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {record.StatusEntry && record.StatusEntry.length > 0 ? (
                                                        record.StatusEntry.map((entry, idx) => (
                                                            <tr key={idx}>
                                                                <td>{entry.DelvDt}</td>
                                                                <td>{entry.DelvTime}</td>
                                                                <td>{entry.Destination_name}</td>
                                                                <td>{entry.Status}</td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={4}>No scans available.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>

                                ))
                            ) : (
                                <div>No shipment details available.</div>
                            )}

                        </div>
                    </div>
                </Modal >

            </div >

    )
}

export default Searchbar;